import {HttpAxiosRequest} from 'src/http/httpAxiosBase'
import {
  CuentasTransferenciaTerceros,
  CuentaTransferenciaTerceros,
  OperacionTransferenciaTerceros, schemaCuentasTransferenciaTerceros, schemaOperacionTransferenciaTerceros,
} from '../types/types'
import {BaseResponse, EntityWithIdFields} from 'src/types'
import {
  OperacionTransferenciasTercerosChequeosComplianceInsert,
  OperacionTransferenciasTercerosChequeosComplianceUpdate,
  OperacionTransferenciasTercerosChequeosComplianceVista,
  OperacionTransferenciaTercerosDetalleUpdate, OperacionTransferenciaTercerosFinalizar,
  OperacionTransferenciaTercerosInsert, schemaOperacionTransferenciasTercerosChequeosComplianceInsert,
  schemaOperacionTransferenciasTercerosChequeosComplianceUpdate,
  schemaOperacionTransferenciasTercerosChequeosComplianceVista,
  schemaOperacionTransferenciaTercerosDetalleUpdate,
  schemaOperacionTransferenciaTercerosFinalizar,
  schemaOperacionTransferenciaTercerosInsert
} from '../types/dto'
import {
  OperacionTransferenciasTercerosChequeosComplianceFields,
  OperacionTransferenciaTercerosFields
} from "../types/fields";
import {HttpOperacionInforme} from "../../../api/httpOperacionInforme";
import {SistemaTipo} from "../../../../../types/enum/enum";

export const getEndpoint = (url = '') => `operaciones/transferencia-terceros${url}`

export const HttpTransferenciaTerceros = {
  get: (idOperacion: number): Promise<OperacionTransferenciaTerceros> => {
    return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}`))
      .then(response => {
        const parsed = schemaOperacionTransferenciaTerceros.safeParse(response)

        if (!parsed.success) {
          console.error('Error de validación:', parsed.error.issues)

          return Promise.reject(new Error('Error de validación.'))
        }

        return parsed.data
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },

  post: (operacion: OperacionTransferenciaTercerosInsert): Promise<BaseResponse> => {
    const parsed = schemaOperacionTransferenciaTercerosInsert.safeParse(operacion)

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues)

      return Promise.reject(new Error('Error de validación.'))
    }

    const formData = new FormData();
    formData.append('operacionInsertarJson', JSON.stringify(operacion));
    operacion[OperacionTransferenciaTercerosFields.Cuentas].forEach((cuenta, index) => {
      formData.append('files', cuenta.file);
    });

    return HttpAxiosRequest.post(getEndpoint(), formData)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },


  putDetalle: (
    idOperacion: number,
    idDetalle: number,
    detalle: OperacionTransferenciaTercerosDetalleUpdate
  ): Promise<BaseResponse> => {
    const parsed = schemaOperacionTransferenciaTercerosDetalleUpdate.safeParse(detalle)

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues)

      return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.put(getEndpoint(`/${idOperacion}/detalles/${idDetalle}`), parsed.data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },

  getCuentas: (idOperacion: number): Promise<CuentaTransferenciaTerceros[]> => {
    return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}/cuentas`))
      .then(response => {
        const parsed = schemaCuentasTransferenciaTerceros.safeParse(response)

        if (!parsed.success) {
          console.error('Error de validación:', parsed.error.issues)

          return Promise.reject(new Error('Error de validación.'))
        }

        return parsed.data
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },

  deleteCuenta: (idOperacion: number, idCuenta: number): Promise<BaseResponse> => {
    return HttpAxiosRequest.delete(getEndpoint(`/${idOperacion}/cuentas/${idCuenta}`))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },

    getChequeosCompliance: (data: number): Promise<OperacionTransferenciasTercerosChequeosComplianceVista> => {
      return HttpAxiosRequest.get(getEndpoint(`/${data}/chequeos-compliance`))
        .then(response => {
          if (response) {
            const parsed = schemaOperacionTransferenciasTercerosChequeosComplianceVista.safeParse(response)

            if (!parsed.success) {
              console.error('Error de validación:', parsed.error.issues)

              return Promise.reject(new Error('Error de validación.'))
            }

            return Promise.resolve(parsed.data)
          }
          else {
            return Promise.resolve(response)
          }

        })
        .catch(error => {
          console.error('Error de red:', error)

          return Promise.reject('Error de red.')
        })
    },

  putChequeosCompliance: (idOperacion: number, data: OperacionTransferenciasTercerosChequeosComplianceUpdate): Promise<BaseResponse> => {
    const parsed = schemaOperacionTransferenciasTercerosChequeosComplianceUpdate.safeParse(data)

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues)

      return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.put(getEndpoint(`/${idOperacion}/chequeos-compliance/${data[EntityWithIdFields.Id]}`), parsed.data)
      .then(response => {
        return Promise.resolve(response.data)
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },

  postChequeosCompliance: (idOperacion: number, data: OperacionTransferenciasTercerosChequeosComplianceInsert): Promise<BaseResponse> => {
    const parsed = schemaOperacionTransferenciasTercerosChequeosComplianceInsert.safeParse(data)

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues)

      return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.post(getEndpoint(`/${idOperacion}/chequeos-compliance`), parsed.data)
      .then(response => {
        return Promise.resolve(response.data)
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },

  finalizarOperacion: (operacionFinalizar: OperacionTransferenciaTercerosFinalizar): Promise<BaseResponse> => {
    const parsed = schemaOperacionTransferenciaTercerosFinalizar.safeParse(operacionFinalizar)

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues)

      return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.post(getEndpoint(
      `/${operacionFinalizar[OperacionTransferenciasTercerosChequeosComplianceFields.IdOperacionTransferenciasTerceros]}/finalizar`),
      parsed.data)
      .then(response => {
        return Promise.resolve(response.data)
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })

  },

  descargarInforme: (idOperacion: number): Promise<any> =>
      HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.TransferenciaTerceros),
} as const
